/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { ReactNode } from "react";

import { ActiveSectionProvider } from "./ActiveSectionContext";

import "./DropdownMenu.scss";

interface DropdownMenuProps {
  defaultSection: string;
  children: ReactNode;
}

export const DropdownMenu = (props: DropdownMenuProps) => {
  const { defaultSection, children } = props;

  return (
    <div className="DropdownMenu">
      <ActiveSectionProvider defaultSection={defaultSection}>
        {children}
      </ActiveSectionProvider>
    </div>
  );
};
